import PropTypes from 'prop-types';
import DatalistInput from 'react-datalist-input';
import causeList from '../utills/CauseList';
import './option-dropdown.css';

const CauseOptions = ({ value, onChange }) => (
  <div className="datalist-input-container">
    <DatalistInput
      placeholder="Select cause"
      value={value}
      onSelect={(item) => onChange(item.value)}
      items={causeList}
    />
  </div>
);

CauseOptions.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CauseOptions;
